// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608181234/js/" + chunkId + "." + {"44":"6c065f7d","225":"34097d3e","481":"ff0b1bd0","486":"a0349737","770":"61371a43"}[chunkId] + ".0.5620752468659238.chunk.js";
};